import React from 'react';

const TermsOfServicesPage = () => {
    return (<>
    <h1>Terms and Conditions</h1>
    <p><strong>Effective date:</strong> June 27, 2025</p>
    <h2>1. Acceptance of Terms</h2>
    <p>By using our data dashboard application (Gemius Programmatic Dashboard), you agree to comply with and be bound by the following terms and conditions.</p>
    <h2>2. Use of the application</h2>
    <p>The application is intended for use by authorized clients only. Each user is responsible for keeping their access credentials confidential.</p>
    <h2>3. Data Ownership</h2>
    <p>Clients retain full ownership of their data. The application only processes and displays data temporarily for authorized users.</p>
    <h2>4. Restrictions</h2>
    <p>You may not distribute, sublicense, modify, reverse-engineer, or resell any part of the application or the data it processes.</p>
    <h2>5. Limitation of Liability</h2>
    <p>The application is provided "as is" without warranties of any kind. We shall not be liable for any loss or damage arising from your use of the application.</p>
    <h2>6. Changes to the Terms</h2>
    <p>We reserve the right to update these terms at any time. Continued use of the application after changes constitutes acceptance of the revised terms.</p>
    <h2>7. Contact</h2>
    <p>If you have any questions regarding these Terms and Conditions, contact us at <a href="mailto:help.ro@gemius.com">help.ro@gemius.com</a></p>
    </>)
}

export default TermsOfServicesPage;